import type { CreanceRow } from "@/lib/creance.api";
import { cn } from "@/lib/utils";

export function CreanceStatusBadge({ creance }: { creance: CreanceRow }) {
  return (
    <span
      className={cn(
        "inline-block rounded px-2 py-0.5 text-[10.5px] font-semibold",
        creance.isOverdue ? "bg-danger-bg text-danger-text" : "bg-warning-bg text-warning-text",
      )}
    >
      {creance.isOverdue ? "En retard" : "Impayée"}
    </span>
  );
}
